import { BrowserRouter } from 'react-router-dom';

import { DemoRoot } from '@/demo';
import { AuthProvider } from '@/domains/auth';
import { AppRoutes } from '@/routes';

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        {/* The demo's state and its guide, when runtime config turns the demo on — nothing otherwise. */}
        <DemoRoot>
          <AppRoutes />
        </DemoRoot>
      </AuthProvider>
    </BrowserRouter>
  );
}
